/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbUserGridDto
 */
export interface FcbUserGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbUserGridDto
     */
    iduser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbUserGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbUserGridDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbUserGridDto
     */
    login?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbUserGridDto
     */
    connecte?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbUserGridDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FcbUserGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbUserGridDto
     */
    gsm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbUserGridDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbUserGridDto
     */
    notifySuiviHope?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbUserGridDto
     */
    notifySuiviSmile?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbUserGridDto
     */
    notifySuiviObserver?: boolean | null;
}

/**
 * Check if a given object implements the FcbUserGridDto interface.
 */
export function instanceOfFcbUserGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbUserGridDtoFromJSON(json: any): FcbUserGridDto {
    return FcbUserGridDtoFromJSONTyped(json, false);
}

export function FcbUserGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbUserGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iduser': !exists(json, 'iduser') ? undefined : json['iduser'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'login': !exists(json, 'login') ? undefined : json['login'],
        'connecte': !exists(json, 'connecte') ? undefined : json['connecte'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'gsm': !exists(json, 'gsm') ? undefined : json['gsm'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'notifySuiviHope': !exists(json, 'notifySuiviHope') ? undefined : json['notifySuiviHope'],
        'notifySuiviSmile': !exists(json, 'notifySuiviSmile') ? undefined : json['notifySuiviSmile'],
        'notifySuiviObserver': !exists(json, 'notifySuiviObserver') ? undefined : json['notifySuiviObserver'],
    };
}

export function FcbUserGridDtoToJSON(value?: FcbUserGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iduser': value.iduser,
        'nom': value.nom,
        'prenom': value.prenom,
        'login': value.login,
        'connecte': value.connecte,
        'actif': value.actif,
        'telephone': value.telephone,
        'gsm': value.gsm,
        'email': value.email,
        'notifySuiviHope': value.notifySuiviHope,
        'notifySuiviSmile': value.notifySuiviSmile,
        'notifySuiviObserver': value.notifySuiviObserver,
    };
}

